import classes from "./Pane.module.css";

function Pane(props) {
    return <div className={classes.pane}>{props.children}</div>
}

export default Pane;